module.exports = __webpack_public_path__ + "img/num01_white.ff59427b.svg";